// extracted by mini-css-extract-plugin
module.exports = {"CompanyPhone":"index-module_CompanyPhone_j02Nk"};